import muthoot from "../../../Assets/projects/caseStudy/muthoot.jpg";
import speehive from "../../../Assets/projects/caseStudy/speehive.jpg";
import al_ansari from "../../../Assets/projects/caseStudy/al_ansari.jpg";
import ashok_tradelines from "../../../Assets/projects/caseStudy/atl.jpg";
import purplecore from "../../../Assets/projects/caseStudy/purpleCore.jpg";
import treat from "../../../Assets/projects/caseStudy/treat.jpg";



export const projects = [
    {
      id: "muthoot",
      heading: "Enterprise Solutions",
      title: "How Virtuosoft Enabled Muthoot EXIM Bank to reduce the wait times for a walk-in customer by 6X",
      client: [
        "Muthoot EXIM Pvt. Ltd., which is a large Indian Corporate with Pan-India Gold Loan Business"
      ],
      image: muthoot,
      summary: [
        "Enterprise-level ERP solution designed to streamline the Gold Purchasing process in both B2B retail and auction modes. The system allows price determination either before or after melting, based on customer preference and predefined processes.",
        "Once the gold is purchased, it is submitted to the refinery, the amount is collected, and the corresponding payout is made to the end customer. All related transactions are automatically updated in the accounting system to ensure accurate financial tracking.",
      ],
      challenges: [
        {
          title: "Inefficient Processes",
          description: "Failed transactions required restarting the entire process."
        },
        {
          title: "Scalability Limitations",
          description: "The system couldn't support business growth or adaptability."
        },
        {
          title: "Manual Approvals",
          description: "Reliance on calls and emails for approvals caused delays and errors."
        },
        {
          title: "Cumbersome Inventory Management",
          description: "Stock handling was manual and error-prone."
        },
        {
          title: "Poor Customer Experience",
          description: "Long wait times frustrated customers."
        },
        {
          title: "Data Issues",
          description: "Problems with data integrity, including duplicates and inaccuracies."
        }
      ],
      solution: [
        {
          title: "Faster Purchases",
          description: "The process was streamlined for speed and efficiency."
        },
        {
          title: "Better Usability",
          description: "User-friendly interfaces and real-time tracking enhanced usability."
        },
        {
          title: "Flexible Workflow",
          description: "Users can resume and edit purchases at any stage."
        },
        {
          title: "Scalable Architecture",
          description: "Microservices enable better scalability and adaptability."
        },
        {
          title: "Improved Inventory Control",
          description: "Stock management became more efficient and reliable."
        },
        {
          title: "Automated Approvals",
          description: "Business rule–driven workflows replaced manual approvals."
        },
        {
          title: "Enhanced Customer Experience",
          description: "Customer wait times were drastically reduced from 3 hours to 30 minutes."
        }
      ],
      benefit: [
        "Wait times for a walk-in customer reduced drastically by 6X"
      ],
      technology: [
        ".NET Core 6.0",
        "MS SQL Server",
        "Angular 15",
        "Micro Service Architecture",
        "Kubernetes Service",
        "Azure Storage Container",
        "Integration with external APIs",
        "Integration with Orion ERP",
        "Azure DevOps"
      ]
    },

    {
        id: "maritime",
        heading: "Fleet Reporting & QA Optimization",
        title: "How Virtuosoft helped Scorpio improve report generation by 15X and streamline QA practices",
        client: [
          "Customer is a leading provider of Futuristic Technology Solutions in the Global Maritime Industry."
        ],
        image: speehive,
        summary: [
          "Provided architectural design and development support for a reporting framework with asynchronous and parallel processing capabilities, significantly improving report generation time.",
          "This enhancement led to improved client satisfaction and contributed to overall business growth."
        ],
        challenges: [
          {
            title: "Slow or Failing Report Generation",
            description: "The process of generating reports to track fleet performance was either failing or extremely slow."
          },
          {
            title: "Legacy Excel Macro Reports",
            description: "The reports were generated using Excel Macros, which were fragile and prone to errors."
          },
          {
            title: "Lack of Standardized Processes",
            description: "There were no standardized procedures in place for development and QA, leading to inconsistencies and inefficiencies."
          }
        ],
        solution: [
          {
            title: "Database and Query Optimization",
            description: "Optimized the database structure and refined queries to enhance report generation efficiency."
          },
          {
            title: "Reporting Engine Development",
            description: "Designed a new, streamlined reporting engine for seamless and reliable report generation."
          },
          {
            title: "Standardized Design Practices",
            description: "Established standardized designs for both databases and applications to ensure consistency and scalability."
          },
          {
            title: "Application Performance Enhancement",
            description: "Optimized application performance to improve speed and reliability."
          },
          {
            title: "Best Practices Implementation",
            description: "Guided the team in adopting industry best practices and provided coaching to ensure adherence."
          },
          {
            title: "Technical Consultation for CD/CI",
            description: "Provided expert technical consultation for implementing Continuous Development and Continuous Integration (CD/CI) pipelines."
          },
          {
            title: "Standardized QA Process Implementation",
            description: "Introduced and implemented a standardized quality assurance process to enhance development and testing efficiency."
          }
        ],
        benefit: [
          "Report generation speed improved enormously by 15X"
        ],
        technology: [
          ".NET Core",
          "MS SQL Server"
        ]
      },

      {
        id: "treat-inc",
        heading: "eCommerce Marketplace Aggregator",
        title: "How Virtuosoft Empowered Treat Inc to Launch a Smart Location-Based Coupon Platform",
        client: [
          "Treat Inc, Canada is an eCommerce Marketplace provider for Food, Retail and Services."
        ],
        image: treat,
        summary: [
            "This is a marketing aggregator platform that brings together offers from restaurants, grocery stores, and leisure services, providing them as both static and dynamic coupons. Static coupons are subscription-based, while dynamic coupons are driven by customer loyalty.",
            "The platform features a robust store-location search algorithm that restricts store searches to the customer’s current location. Additionally, Treat Inc offers advanced capabilities for organizing events.",
        ],
        challenges: [
          {
            title: "Nearby Discounts",
            description: "Displays restaurants and other stores offering discounts based on the user’s current location or a chosen preset location."
          },
          {
            title: "Search with Filters",
            description: "Enables users to search for restaurants or other stores, providing a list of options based on their location."
          },
          {
            title: "Tiered Discount Coupons",
            description: "Offers discount coupons in multiple tiers, rewarding users based on predefined conditions."
          },
          {
            title: "Special Deals",
            description: "Offer deals to selected people based on predefined criteria."
          }
        ],
        solution: [
          {
            title: "Customer Registration",
            description: "A simple and intuitive registration module supporting mobile numbers and social media logins."
          },
          {
            title: "Personalized Home Page",
            description: "Displays a list of restaurants and stores based on the user’s location and predefined business rules."
          },
          {
            title: "Enhanced Search Options",
            description: "Offers quick searches by store category and free-text searching for greater flexibility."
          },
          {
            title: "Store Admin Interface",
            description: "Provides store administrators with tools to register, manage, and update store details and discount coupons."
          },
          {
            title: "Data Approval Process",
            description: "Implements a review and approval workflow to ensure data accuracy."
          },
          {
            title: "Tiered Discount Offers",
            description: "Displays customized discount offers based on the frequency of user visits to specific stores."
          },
          {
            title: "Seamless Payment Options",
            description: "Supports multiple payment methods, including Apple Pay, Google Pay, and credit cards."
          },
          {
            title: "User Dashboard",
            description: "Includes a personalized dashboard displaying savings and other relevant details."
          }
        ],
        benefit: [
          "Reliable mechanism to push deals to consumers.",
          "Strong algorithm to search and find nearby stores."
        ],
        technology: [
          ".NET Core",
          "MS SQL Server",
          "Angular",
          "Flutter",
          "Micro Service Architecture",
          "Kubernetes Service",
          "Azure Storage Container",
          "Azure DevOps"
        ]
      },

      {
        id: "redha-al-ansari-exchange",
        heading: "Real-time Fraud Detection System",
        title: "How Virtuosoft Helped Redha Al-Ansari Exchange Detect and Prevent Counterfeit Currency in Real-Time",
        client: [
          "Redha Al-Ansari Exchange has been the leading money exchange company in the UAE, providing online money transfer services, online and offline remittances, and foreign exchange services."
        ],
        image: al_ansari,
        summary: [
         "Centralized system to help detect, report, and analyse counterfeit currency incidents in real-time. It integrates with physical currency detection machines regulatory databases to track counterfeit notes movement, patterns, and statistics. Also, it integrates with multiple payment vendor channels to enable seamless international payments with multi-currency support.",
         "Integrated Payment Facilitators like - Ria Money, TerraPay, Instant Cash, Ezremit, UPT, AlexBank, Habib Metropolitan Bank etc which will be using to make payment from the sender account to the beneficiary account - via Cash Pick up, Bank Transfer and Wallet Channels. It handles input validation, per‑provider payload mapping, real‑time foreign exchange fee calculation, retriable routing with fail‑over and asynchronous status update calls."
        ],
        benefit: [
          "Developed the application to detect and manage counterfeit currency, significantly reducing the risk of fraudulent transactions."
        ],
        technology: [
          ".NET Framework",
          "MSSQL Server",
          "Rest API"
        ]
      },

      {
        id: "ashok-tradelines",
        heading: "ERP System for Construction Material Distribution",
        title: "How Virtuosoft Helped Ashok Tradelines Improve Billing Speed by 30% and Eliminate Stock Reconciliation Downtime",
        client: [
          "Ashok Tradelines, Kerala, India is a large distributor of construction materials."
        ],
        image: ashok_tradelines,
        summary: [
          "ERP system designed to bridge the gap between the procurement process where items are sourced from vendors and the invoicing system used to sell these items to both B2B (dealers) and B2C (walk-in) customers making bulk purchases.",
          "The system follows a task-driven approach, guiding each user persona by prompting their next action based on real-time stock levels and order status. This system enables accurate stock tracking, helping to prevent both understocking and overstocking."
        ],
        benefit: [
          "Ashok Tradelines achieved 30% improvement in their billing speed.",
          "Shut down of business due to delay in stock reconciliation came down to Zero Days."
        ],
        technology: [
          ".NET Core 8.0",
          "MS SQL Server",
          "Angular 18",
          "Docker Containers",
          "Azure Storage Container",
          "Azure DevOps",
          "Azure App Service"
        ]
      },

      {
        id: "purplecore",
        heading: "Cargo Aggregation Platform",
        title: "How Virtuosoft Helped PurpleCore Streamline Air and Marine Cargo Tracking Across Multiple Carriers",
        client: [
          "PurpleCore is a provider of Air/Marine Cargo Tracking Software."
        ],
        image: purplecore,
        summary: [
          "Technology Consultation / Development support for developing an aggregator application for tracking multiple airline and marine cargo services through a single interface."
        ],
        benefit: [
          "This solution eliminates the need to access separate portals for different carriers, streamlining operations and significantly improving tracking efficiency."
        ],
        technology: [
          ".NET Core"
        ]
      }
    
  ];
